import React, { useEffect, useState } from "react";
import { PageHeader } from "../../SharedComponents/PageHeader";

export const RejectionsBI = () => {
  return (
    <div
      className="row"
      style={{
        minHeight: "calc(100vh - 2rem - 56px)",
        backgroundColor: "white",
        marginRight: 0,
        marginLeft: 0,
        alignItems: "center",
      }}
    >
      <iframe
        title="Rejections"
        width="1140"
        height="541.25"
        src="https://app.powerbi.com/reportEmbed?reportId=5f933baa-fd03-416d-bb8b-07413be139c7&autoAuth=true&ctid=edb0e2ad-5f7b-4fcf-bbd2-7425af181ad1"
        frameBorder="0"
        allowFullScreen
        style={{
          minHeight: "calc(100vh - 2rem - 56px)",
        }}
      ></iframe>
    </div>
  );
};
